<template>
  <!-- components/navigationBar/navigationBar.wxml -->
  <!-- 整个导航栏:包括状态栏 -->
  <div :style="`${navBarBfc ? '' : 'height:.8rem;'}flex: 0 0 auto;`" v-show="!hideBar">
    <!-- 避免被遮住，采用fixed定位且z-index置为最高 -->
    <div class="customBarBox">
      <!-- 导航栏内容区域：状态栏下面部分 -->
      <div
        class="bg-class customBarBoxItem  flex"
        :style="`z-index:2;height:.8rem;padding-right:.2rem;font-size:.34rem;color:${textColor}`"
      >
        <!-- @backStyle：返回方式： -->
        <div
          class="flex custom-btn"
          style="min-width:2rem;"
        >
          <!-- 只是显示 返回 -->
          <div
            v-if="backStyle=='back'"
            @click="BackPage"
          >
            <div
              class="iconfont icon-back"
              style="padding:0 .30rem;"
            ></div>
          </div>
          <!-- 只是显示，首页 -->
          <div
            v-else-if="backStyle=='home'"
            @click="toHome"
          >
            <div
              class="iconfont icon-home"
              style="padding:0 .30rem;"
            ></div>
          </div>
          <!-- 显示返回及首页:类似胶囊样式 -->
          <div
            v-else-if="backStyle=='back-home'"
            class="flex  back-home  hairline"
            :style="`width:1.6rem;height:.6rem;margin:0 .2rem;`"
          >
            <div
              class="iconfont icon-back"
              @click="BackPage"
            ></div>
            <div
              class="iconfont icon-home"
              @click="toHome"
            ></div>
          </div>
          <!-- 采用卡槽方式 -->
          <div v-else-if="backStyle=='new'">
            <slot name="back"></slot>
          </div>
        </div>
        <!-- 标题部分 -->
        <!-- 对齐方式:居中 -->
        <div class="flex custom-tit">
          <!-- 如果是文本，超出... -->
          <div
            v-if="contentText"
            class="dots-1"
          >{{contentText}}</div>
          <!-- 传了这个卡槽就会显示 -->
          <slot name="content"></slot>
        </div>
        <div class="right">
          <div class="menu-wrap">
            <div
              class="menu-btn"
              @click="menuVisable = !menuVisable"
            >
              <svg-icon icon-class="icon-more" />
            </div>
            <div
              class="menu"
              v-show="menuVisable"
            >
              <router-link
                class="menu-item"
                to="/"
              >
                <img
                  src="@/assets/images/tab-bar/icon-index-on.png"
                  alt=""
                  srcset=""
                >
                首页</router-link>
              <router-link
                class="menu-item"
                to="/tao"
              >
              <img src="@/assets/images/tab-bar/icon-tao-on.png" alt="" srcset="">
              淘酒</router-link>
              <router-link
                class="menu-item"
                to="/cart"
              >
              <img src="@/assets/images/tab-bar/icon-cart-on.png" alt="" srcset="" style="margin-left: -.03rem;margin-right: 0.18rem;">
              购物车</router-link>
              <router-link
                class="menu-item"
                to="/my"
              >
              <img src="@/assets/images/tab-bar/icon-my-on.png" alt="" srcset="">
              我的</router-link>
            </div>
          </div>

          <!-- right卡槽：待补充 -->
          <slot name="right"></slot>
        </div>

      </div>
    </div>
  </div>
  <!-- 导航栏外部可携带其它组件 ：如进度条，message消息等 -->
</template>

<script>
  export default {
    props: {
      navBarBfc: {
        type: Boolean,
        default: false // 默认导航栏占据空间
      },
      textColor: {
        type: String,
        default: "#000"
      },
      backStyle: {
        type: String,
        default: "back-home" // 默认返回类型：返回图标
      },
      contentText: {
        type: String,
        default: "" // 默认标题为空
      }
    },
    data () {
      return {
        menuVisable: false,
        hideBar: false
      }
    },
    created () {
      let { from } = this.$route.query
      if (from === 'xcx') {
        this.hideBar = true
      }
    },
    methods: {
      BackPage () {
        this.$router.back()
      },
      // 返回首页
      toHome () {
        this.$router.push('/')
      }
    }

  }
</script>

<style lang="scss" scoped>
  /* component/navigationBar/index.wxss */
  @import 'icon.css';

  .customBarBox {
    width: 7.5rem;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    // right: 0;
    z-index: 99;
    /* 网格布局 */
    display: grid;
    grid-template-areas: 'main';
  }
  .customBarBoxItem {
    grid-area: main;
    box-sizing: border-box;
    background-color: #fff;
  }

  /* 返回及首页时样式 */
  .custom-btn {
    /* justify-content: center; */
    align-items: center;
  }
  .back-home {
    /* border: 1px solid grey; */
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10000px; /* 左右半圆 */
    border-color: #e6e6e6;
    display: flex;
  }
  .back-home::before {
    content: '';
    display: block;
    width: 1px;
    height: 0.38rem;
    position: absolute;
    left: 50%;
    top: 50%;
    border-left: 1px solid #c5c5c5;
    transform: translate(-50%, -50%) scaleX(0.5);
    transform-origin: center center;
    margin-right: 1px;
    /* background-color: #c5c5c5; */
  }
  .back-home .iconfont {
    flex: 1 1 auto;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-tit {
    flex: 1 1 auto;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
  }

  /* 以下是常用布局类，放在这边好打包 */
  /* flex容器常用类 */
  .flex {
    display: -webkit-flex; /* Safari */
    display: flex;
  }

  /* 换行 */
  .flex-wrap {
    flex-wrap: wrap;
    align-content: flex-start; /* 默认是stretch则每行底下平分剩余高度空间*/
  }

  /* 默认,不放大，平均缩小*/
  .flex-default {
    /*放大比例*/
    flex-grow: 0;
    /*缩小比例*/
    flex-shrink: 1;
    /* 主轴空间 */
    flex-basis: auto;
  }
  .right {
    min-width: 2rem;
  }
  /* 超出省略号... */
  .dots-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1; /* 多行改这个数字即可*/
    overflow: hidden; /*要设置容器高度，为：line-height*-webkit-line-clamp*/
    /* 否则，虽然会出现...。但如果高度较高，底下还是会展示 */
    /*如果要文字外层使用padding，则在祖父容器设置padding，父容器设置dots*/
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  .menu-wrap {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .menu-btn {
      height: 100%;
      width: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .menu {
      position: absolute;
      right: 0;
      top: 100%;
      background-color: rgba(50, 50, 50, 0.8);
      // background-color: #ba1622;
      margin-top: 0.2rem;
      padding: 0.1rem 0.2rem;
      border-radius: 0.1rem;
      &::before {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-width: 0.1rem;
        border-style: solid;
        border-color: transparent transparent rgba(50, 50, 50, 0.8) transparent;
        position: absolute;
        right: 0.3rem;
        top: -0.2rem;
      }
    }
    .menu-item {
      display: flex;
      font-size: 0.28rem;
      line-height: 2;
      padding: .08rem 0.36rem;
      color: #fff;
      border-bottom: 0.01rem solid #fff;
      align-items: center;
      font-weight: normal;
      white-space: nowrap;
      img {
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 0.15rem;
        object-fit: contain;
      }
      &:last-child {
        border: none;
      }
    }
  }
</style>
